import { z } from "../wire/zod";

export const createSessionResponseSchema = z.object({
  sessionId: z.union([z.string(), z.null()]),
  syncSessionId: z.union([z.string(), z.null()]),
});
export const createTemplateSessionResponseSchema = z.object({
  newTeams: z.array(z.object({ name: z.string(), pw: z.string() })),
  sessionId: z.string(),
});
export const getCompanyStatsResponseSchema = z.object({
  stickyCount: z.number().int(),
  sessionCount: z.number().int(),
});
export const getSessionsResponseSchema = z.object({
  sessions: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      planningDates: z
        .object({
          start: z.union([z.string().date(), z.null()]).optional(),
          end: z.union([z.string().date(), z.null()]).optional(),
        })
        .describe("First and last day of the PI planning event")
        .optional(),
      participatingUsers: z.array(z.number().int()).optional(),
      iterations: z.array(
        z.object({
          id: z.number().int(),
          name: z.string(),
          start: z.number().int(),
          end: z.number().int(),
          teams: z
            .array(
              z.object({
                teamId: z.number().int(),
                sources: z.array(
                  z.object({
                    id: z.number().int(),
                    sprint: z.union([z.number().int(), z.null()]).optional(),
                    acIterationId: z.union([z.number().int(), z.null()]).optional(),
                    iterationPath: z.string().optional(),
                  }),
                ),
              }),
            )
            .optional(),
        }),
      ),
      creationDate: z.string().datetime({ offset: true }),
      settings: z.record(z.string(), z.any()),
      archived: z.boolean().optional(),
      art: z.object({ id: z.number().int() }).optional(),
      solutionTrain: z.object({ id: z.number().int() }).optional(),
      arts: z.array(z.object({ id: z.number().int() })).optional(),
    }),
  ),
});
export const getTemplateSessionsResponseSchema = z.object({
  templates: z.array(z.object({ id: z.string(), name: z.string(), selectable: z.boolean() })),
});
export const getUsersSeeAllSessionsResponseSchema = z.object({ enabled: z.boolean() });
export const noDataSchema = z.record(z.string(), z.never());
export const setUsersSeeAllSessionsResponseSchema = z.object({ enabled: z.boolean() });
